import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

export function smartSplitTitle(titleString, truncateModeEnabled) {
    if (_.isString(titleString)) {
        return titleString;
    } else {
        let title;
        if (titleString.length > 1) {
            title = titleString;
        } else {
            title = [
                titleString[0].split(/ (.+)/)[0],
                titleString[0].split(/ (.+)/)[1],
            ];
        }
        return [
            <div
                className={
                    truncateModeEnabled ? 'first-item truncate' : 'first-item'
                }
                key={2}
            >
                {title[0]}
            </div>,
            <span className={truncateModeEnabled ? 'truncate' : ''} key={1}>
                {title[1]}
            </span>,
        ];
    }
}

class Card extends React.Component {
    getDefaultFooterContent = () => {
        let rightFooterContent = null;
        let leftFooterContent = null;
        if (this.props.right.content || this.props.right.title) {
            if (this.props.right.title) {
                rightFooterContent = (
                    <div className="card-footer-right">
                        <div
                            data-toggle="tooltip"
                            title={this.props.right.title}
                        >
                            {this.props.right.content}
                        </div>
                    </div>
                );
            } else {
                rightFooterContent = (
                    <div className="card-footer-right">
                        {this.props.right.content}
                    </div>
                );
            }
        }

        if (this.props.left.content || this.props.left.title) {
            if (this.props.left.title) {
                leftFooterContent = (
                    <div className="card-footer-left">
                        <div
                            data-toggle="tooltip"
                            title={this.props.left.title}
                        >
                            {this.props.left.content}
                        </div>
                    </div>
                );
            } else {
                leftFooterContent = (
                    <div className="card-footer-left">
                        {this.props.left.content}
                    </div>
                );
            }
        }

        let footerContent = null;
        if (rightFooterContent || leftFooterContent) {
            footerContent = (
                <div className="card-footer">
                    {leftFooterContent}
                    {rightFooterContent}
                </div>
            );
        }
        return footerContent;
    };

    getFooterContent = (items) => {
        return <div>{items}</div>;
    };

    render() {
        const title = smartSplitTitle(
            this.props.title,
            this.props.truncateModeEnabled
        );
        const footerItems = this.props.footerItems;
        const footerCls = footerItems ? 'card-multi-line' : '';

        let footerContent;
        if (!footerItems) {
            footerContent = this.getDefaultFooterContent();
        } else {
            footerContent = this.getFooterContent(footerItems);
        }

        const {
            className: extraClassName = '',
            type: propType = '',
            ...forwardedProps
        } = this.props;

        const rootClassName = [
            'card',
            'level-1',
            'clickbox',
            propType,
            footerCls,
            extraClassName,
        ]
            .filter(Boolean)
            .join(' ')
            .trim();

        return (
            <div className={rootClassName} {...forwardedProps}>
                <div className="card-content pb-10">
                    <h2 className="headline1"> {title} </h2>
                    {this.props.children}
                </div>
                {footerContent}
            </div>
        );
    }
}

Card.defaultProps = {
    title: ['Title', 'titley'],
    type: '',
    truncateModeEnabled: false,
    left: {
        content: null,
        title: null,
    },
    right: {
        content: null,
        title: null,
    },
};

Card.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    type: PropTypes.oneOf([
        'card-primary',
        'card-info',
        'card-edit',
        'card-alert',
        'card-add',
        '',
    ]),
    left: PropTypes.object,
    right: PropTypes.object,
    children: PropTypes.node,
    truncateModeEnabled: PropTypes.bool,
};

export default Card;
